import { render, staticRenderFns } from "./productsCategories.vue?vue&type=template&id=435f0439&"
import script from "./productsCategories.vue?vue&type=script&lang=js&"
export * from "./productsCategories.vue?vue&type=script&lang=js&"
import style0 from "./productsCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports